// extracted by css-extract-rspack-plugin
export default {"chip":"pQTkqLy8pmMlhljd","tiny":"QfOoQ25VJE5fcATh","small":"LrviLYpmekc9F1EH","medium":"DnUQvBk4M4UTMjhC","large":"ZGMaVMVuovE6NfRp"};